class Interface {
    KNOG_NEWCOMMAND = 0x24;
    KNOG_WAIT = 0xFF;
    DELAY_USB_POLL_RATE = 10;	// milliseconds.
    WRITE_BLOCK_SIZE = 32;

    BOOT_CMD_SETUP = 0x31;	// '1'
    BOOT_CMD_ERASE = 0x32;	// '2'
    BOOT_CMD_WRITE = 0x33;	// '3'
    // BOOT_CMD_WNVM = 0x37;	// '7'

    BOOT_CMD_VERIFY = 0x34;	//  '4'
    // BOOT_CMD_RUNAPP = 0x36;	//  '6'
    BOOT_CMD_RNVM = 0x38;	//  '8'
    KNOG_CMD_VERSION = 0x39;

    BOOT_ACK_REPLY = 0x40; // '@'
    BOOT_ERR_RANGE = 0x41; //  'A'
    // BOOT_ERR_BADID = 0x42; //  'B'
    // BOOT_ERR_CRC = 0x43; //  'C'
    BOOT_INVALID_DEVICE = 0x45; //'E'	
    BOOT_SEND_DATA_PACKAGE = 0xFF;	// payload from a read.

    delay: number = 10;
    seqno: {value: number};

    selectedDevice: any; 
    logger: Function | null;
    verbose: boolean;

    constructor(device: any, logger: Function | null, seqno: {value: number}, verbose: boolean) {
        this.selectedDevice = device;
        this.logger = logger;
        this.seqno = seqno;
        this.verbose = verbose;
    }

    log(message: string | undefined) {
        if(this.logger && message) {
            this.logger(message)
        }
    }

    async command(commandcode: number, data: any, return_size_max: number, timeout_ms: number) {
        this.seqno.value += 1;
        if(this.verbose) console.log("seqno: " + this.seqno.value);
        if (this.seqno.value > 120) { this.seqno.value = 2; }
        let command = new Uint8Array(data.byteLength + 4);
        command[0] = this.KNOG_NEWCOMMAND;
        command[1] = 2 + data.byteLength;
        command[2] = commandcode;
        command[3] = this.seqno.value
        if (data.byteLength > 0) {
            command.set(data, 4);
        }
        // standard Knog fare
        let setup = { requestType: 'vendor', recipient: 'device', request: 0x12, value: 10, index: 0 };
        return await this.selectedDevice.controlTransferOut(setup, command).then((data: any) => {
            if (data.bytesWritten !== command.byteLength) {
                return "KnogCommand => USB Send did not transfer the correct amount of bytes";
            }
            if (data.status !== 'ok') {
                return "KnogCommand => USB transfer not OK";
            }
        }).then(async () => {
            return await this.fetch((timeout_ms / this.DELAY_USB_POLL_RATE), 0, return_size_max)
                .then((response: any) => {
                    if (!response) return "KnogCommand => No response from device";
                    else if (response.seq === this.seqno.value) return {isSuccess: true, ...response};
                    else return "KnogCommand => Returned frame id does not match. request = " + this.seqno.value 
                        + " Response = " + (response.seq ?? JSON.stringify(response));
                })
                .catch((error: any) => { return "KnogCommand => " + error; });
        });
    }

    async fetch(iterid: number, delay: number, return_size_max: number): Promise<any> {

        if (return_size_max === undefined) { return "Undefined return size."; }
        if(this.verbose) console.log("iterid: " + iterid);
         
        const setup = { requestType: 'vendor', recipient: 'device', request: 0x12, value: 10, index: 0x12 };
        return await new Promise(resolve => setTimeout(resolve, delay))
            .then(() => this.selectedDevice.controlTransferIn(setup, return_size_max + 8))
            .then((transfer: any) => {
                let binarray = new Uint8Array(transfer.data.buffer);
                if (binarray.byteLength < 1) return "USB frame received has no data. Invalid frame from device.";

                if (binarray[0] === this.KNOG_WAIT) {	// call us recursively
                    if (delay === 0)  delay = this.DELAY_USB_POLL_RATE;
                    const response = this.fetch(iterid - 1, delay, return_size_max)
                        .then((res) => res)
                        .catch((error) => error);
                    if (iterid > 1) return response
                    else return {message: `KnogFetchResult => Iteration limit reached (${this.seqno.value})`, response}
                } else {	// valid first byte. not wait.
                    if (binarray.byteLength < 2) return "USB frame received has only one byte. There is a protocol problem. the only 1 byte frame should be a wait response FF";
                    else return { 'id': binarray[0], 'seq': binarray[1], data: binarray.slice(2, binarray.length) };
                }
            })
            .catch((error: any) => {
                return "KnogFetchResult => " + error;
            });
    }

    async getCRC(bottomAddress: number, topAddress: number): Promise<number> {
        try {
            const response: { data: number[] } = await this.command(
                this.BOOT_CMD_VERIFY,
                new Uint8Array([
                    (bottomAddress >> 8) & 0xff, // High byte of bottomAddress
                    bottomAddress & 0xff, // Low byte of bottomAddress
                    (topAddress >> 8) & 0xff, // High byte of topAddress
                    topAddress & 0xff, // Low byte of topAddress
                    0, // Reserved byte
                    0  // Reserved byte
                ]),
                5,
                60
            );
    
            if (!response.data || response.data.length !== 3) {
                this.log(`KnogGetCRC: Byte length incorrect. Expected 3, got ${JSON.stringify(response)}`);
                return 0;
            }
    
            return (response.data[1] << 8) | response.data[2]; // Combine bytes using bitwise OR
        } catch (error) {
            console.error(error);
            return 0;
        }
    }

    async read(address: number, length: number): Promise<Record<string, any>> {
        if (length < 1) {
            return {
                isSuccess: false,
                errorMessage: "KnogReadFlashCmd => Data length less than 1 byte",
            };
        }
    
        const data = new Uint8Array(3);
        data[0] = Math.floor(address / 256) & 0xff;
        data[1] = address & 0xff;
        data[2] = length;
    
        const responseKnogCommand: Record<string, any> = await this.command(
            this.BOOT_CMD_RNVM,
            data,
            length + 5,
            300
        );
    
        if (!responseKnogCommand.isSuccess) {
            return responseKnogCommand;
        }
    
        if ((responseKnogCommand.data as Uint8Array).byteLength !== (1 + length)) {
            return {
                isSuccess: false,
                errorMessage: `KnogReadFlashCmd => Byte length incorrect. (Should be ${1 + length}) was ${(responseKnogCommand.data as Uint8Array).byteLength}`,
            };
        }
    
        const listData: number[] = Array.from(responseKnogCommand.data as Uint8Array);
    
        if (listData[0] === this.BOOT_SEND_DATA_PACKAGE) {
            const dataList = listData.slice(1).map(byte => byte ^ 0x15); // Descramble data
    
            return {
                isSuccess: true,
                dataList: dataList,
            };
        }
    
        if (listData[0] === this.BOOT_ERR_RANGE) {
            return {
                isSuccess: false,
                errorMessage: `KnogReadFlashCmd => Range error. Check the address of ${address}`,
            };
        }
    
        return {
            isSuccess: false,
            errorMessage: `KnogReadFlash => Unrecognised error. Check the address of ${address} Error code ${listData[0]}`,
        };
    }

    async setKeys(): Promise<{ isSuccess: boolean; message?: string }> {
        let result: { isSuccess: boolean; message?: string } = { isSuccess: true };
    
        const response = await this.command(
            this.BOOT_CMD_SETUP, new Uint8Array([0xA5, 0xF1, 0]), 5, 30
        );

        if(!response.data) {
            return {
                isSuccess: false,
                message: response
            };
        }
    
        if (response.data.byteLength !== 1) {
            return {
                isSuccess: false,
                message: `KnogSetKeys => Byte length incorrect. (Should be 1) was ${response.data.byteLength}`
            };
        }
    
        switch (response.data[0]) {
            case this.BOOT_ACK_REPLY:
                return { ...result, message: "OK" };
            case this.BOOT_ERR_RANGE:
                return { isSuccess: false, message: "KnogSetKeys => Range error." };
            default:
                return { isSuccess: false, message: `KnogSetKeys => Unknown error ${response.data[0]}` };
        }
    }
    
    async erase(address: number): Promise<{ isSuccess: boolean; message?: string }> {
        let result: { isSuccess: boolean; message?: string } = { isSuccess: true };

        const response = await this.command(
            this.BOOT_CMD_ERASE,
            new Uint8Array([(address >> 8) & 0xFF, address & 0xFF]),
            5,
            300
        );

        if(!response.isSuccess) {
            return {
                isSuccess: false,
                message: response
            };
        }
    
        if (response.data.byteLength !== 1) {
            return {
                isSuccess: false,
                message: `knogEraseFlash => Byte length incorrect. (Should be 1) was ${response.data.byteLength}`
            };
        }
    
        switch (response.data[0]) {
            case this.BOOT_ACK_REPLY:
                return { ...result, message: "OK" };
            case this.BOOT_ERR_RANGE:
                return { isSuccess: false, message: `KnogEraseFlash => Range error. Check address of ${address}` };
            case this.BOOT_INVALID_DEVICE:
                return { isSuccess: true, message: `KnogEraseFlash => NON GENUINE at ${address}` };
            default:
                return { isSuccess: false, message: `KnogEraseFlash => Unknown error. Check address of ${address}. Error code ${response.data[0]}` };
        }
    }
    
    async eraseRange(start: number, end: number): Promise<{ isSuccess: boolean; message?: string }> {
        let result: { isSuccess: boolean; message?: string } = { isSuccess: true };
        for (let i = start; i < end; i++) {
            try {
                const response = await this.erase(i * 512);
                result.message = response.message;
                if (!response.isSuccess) {
                    return { isSuccess: false, message: response.message };
                }
            } catch (error) {
                return { isSuccess: false, message: `KnogEraseFlash => ${error}` };
            }
        }
    
        return { ...result, message: "OK" };
    }
    
    async programFlash(address: number, blockData: Uint8Array): Promise<{ isSuccess: boolean; message?: string }> {
        if (blockData.byteLength < 1) {
            return { isSuccess: false, message: "KnogProgramFlash => Data length less than 1 byte" };
        }

        let dataToWrite = new Uint8Array(blockData.byteLength + 2);
        dataToWrite[0] = (address >> 8) & 0xFF;
        dataToWrite[1] = address & 0xFF;
        dataToWrite.set(blockData, 2);

        const commandResponse = await this.command(this.BOOT_CMD_WRITE, dataToWrite, 5, 300);
    
        if (commandResponse.data.byteLength !== 1) {
            return {
                isSuccess: false,
                message: `KnogProgramFlashCmd => Byte length incorrect. (Should be 1) was ${commandResponse.data.byteLength}`
            };
        }
    
        switch (commandResponse.data[0]) {
            case this.BOOT_ACK_REPLY:
                return { isSuccess: true, message: "OK" };
            case this.BOOT_INVALID_DEVICE:
                return { isSuccess: true, message: "Invalid Device" };
            case this.BOOT_ERR_RANGE:
                return { isSuccess: false, message: `KnogProgramFlashCmd => Range error. Check address of ${address}` };
            default:
                return { isSuccess: false, message: `KnogProgramFlashCmd => Unknown error. Check address of ${address}. Error code ${commandResponse.data[0]}` };
        }
    }
    
    async program(address: number, data: Uint8Array): Promise<{ isSuccess: boolean; message?: string }> {
        if (data.byteLength < 1) {
            return { isSuccess: false, message: "KnogProgramFlash => Data length less than 1 byte" };
        }
        if(this.verbose) console.log("Program:", address, data)
        let consumed = 0;
        while (consumed < data.byteLength) {
            let blockLength = Math.min(this.WRITE_BLOCK_SIZE, data.byteLength - consumed);
            try {
                const response = await this.programFlash(address, data.slice(consumed, consumed + blockLength));
                if (!response.isSuccess) {
                    return { isSuccess: false, message: "KnogProgramFlash => " + response.message };
                }
            } catch (e) {
                return { isSuccess: false, message: `KnogProgramFlash => ${e}` };
            }
    
            address += this.WRITE_BLOCK_SIZE;
            consumed += this.WRITE_BLOCK_SIZE;
        }
    
        return { isSuccess: true, message: "OK" };
    }
    
    async programBlocks(blocks: { start_address: number; data: any }[], setProgress: Function = () => {}): Promise<{ isSuccess: boolean; message?: string }> {
        for (const block of blocks) {
            setProgress(blocks.indexOf(block) / blocks.length * 100);
            try {
                const dataList = Object.values(block.data);
                const dataBlock = new Uint8Array(dataList.length);
    
                Object.keys(block.data).forEach((key, index) => {
                    dataBlock[index] = block.data[key];
                });

                const response = await this.program(block.start_address, dataBlock);
                if (!response.isSuccess) {
                    return { isSuccess: false, message: "KnogProgramBlocks => " + response.message };
                }
            } catch (error) {
                return { isSuccess: false, message: `KnogProgramBlocks => ${error}` };
            }
        }
    
        return { isSuccess: true, message: "OK" };
    }

    scramble(values: any) {
        Object.keys(values.data).forEach((key) => {
            values.data[key] = values.data[key] ^ 0x15;
        });
    }
}

export default Interface;